import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const loginHeaderStyle = {
    right: css`
        display: flex;
    `,
    formLogin: css`
        display: flex;
        gap: 10px;
    `,
    bgForm: css`
        /* background: #2d276d; */
        padding: 2px 4px;
        border-radius: 3px;
    `,
    inputWrap: css`
        display: flex;
        /* background-color: ${colors.white}; */
        border-radius: 3px;
        flex-direction: column;
    `,
    inputlog: css`
        background: #fff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 2px 3px 2px 10px;
        border: 1px solid #000;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .5);
        width: 217px;
    `,
    input: css`
        border: none;
        background: none;
        margin-left: 8px;
        padding: 8px 0;
        width: 115px;
        height: 32px;
        font-size: 16px;
        color: #000;
        &:placeholder-shown {
            font-size: 13px;
            transform: translateY(1px);
        }
    `,

    icon: css`
        height: 16px;
    `,
    remember: css`
        display: flex;
        align-items: center;
        margin-left: 2px;
        label {
            margin-left: 5px;
            font-size: 12px;
        }
    `,
    forgetPw: css`
        color: #E9FF00;
        font-size: 12px;
        cursor: pointer;
        text-align: left;
        margin-top: 5px;
        margin-left: 2px;
        &:hover {
            text-decoration: underline;
        }
    `,
    togglePw: css`
        cursor: pointer;
        display: flex;
        height: 100%;
        align-items: center;
        margin-left: 40px;
        img {
            width: 18px;
        }
    `,
    btnGroup: css`
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: 20px;
        button {
            font-size: 0.9rem;
            padding: 3px 7px;
            border-radius: 5px;
            font-weight: bold;
            font-size: 0.9rem;
            color: #fff;
            background: linear-gradient(to bottom, #E02B35, #9A1A34);
            cursor: pointer;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
            &:hover {
                color: #fff;
                opacity: 0.8;
                transform: scale(1.05);
                background: #fc0d0d;
            }

            &:focus {
                box-shadow: none;
            }
            &:nth-child(2) {
                background: linear-gradient(to bottom, #009F73, #005A42);
            }
        }
    `,
};
export default loginHeaderStyle;
